import React from 'react';
import moment from 'moment';
import {
  MenuFolder,
  MenuItemType,
  MenuRow,
} from 'components/containers/CollapsableMenu';
import DocumentRow from 'components/rows/DocumentRow';
import { GraphQLDocumentObjectType } from 'types/documents-types';

export const createInvestmentsItems = (
  multiInvestments: GraphQLDocumentObjectType[][]
) => {
  const items: (MenuFolder | MenuRow)[] = [];
  multiInvestments.forEach((investments) => {
    if (investments.length === 1) {
      const investment = investments[0];
      items.push({
        type: MenuItemType.Row,
        row: (
          <DocumentRow
            title={investment.documentLabel}
            uri={investment.documentUri}
            subtitle={moment(investment.dateCreated).format('MMMM DD, YYYY')}
          />
        ),
      });
    } else {
      const rows: MenuRow[] = [];
      investments.forEach((investment) => {
        rows.push({
          type: MenuItemType.Row,
          row: (
            <DocumentRow
              title={investment.documentLabel}
              uri={investment.documentUri}
              subtitle={moment(investment.dateCreated).format('MMMM DD, YYYY')}
            />
          ),
        });
      });
      items.push({
        type: MenuItemType.Folder,
        title: investments[0].documentLabel.split(' - ')[0],
        rows,
      });
    }
  });
  return items;
};
